module.exports = __webpack_public_path__ + "img/image.e8635e5d.svg";